<template>
  <div class="container mt-5">
    <h1>Lista pazienti</h1>
    <div v-if="loading" id="loading">
      <div id="loading-text">
        Caricamento...
      </div>
      <div class="spinner-border text-dark" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div v-else>
      <ul v-if="patientsIDs.length" class="fancy-list">
        <li v-for="id in patientsIDs" :key="id">
          <span class="item-icon">👤</span>
          <router-link :to="`/patient/${id}`">{{ id }}</router-link>
        </li>
      </ul>
      <p v-else>Nessun paziente trovato.</p>
    </div>
  </div>
</template>

<script>
import {useHead} from "@vueuse/head";

export default {
  setup() {
    useHead({
      title: 'VISAD Dashboard - Lista pazienti'
    });
  },
  data() {
    return {
      patientsIDs: [],
      loading: false,
    };
  },
  mounted() {
    this.getDocumentIds();
  },
  methods: {
    async getDocumentIds() {
      this.loading = true;
      // const collectionName = "users"; // Sostituisci con il nome della tua collezione
      // const collectionRef = collection(db, collectionName);
      // try {
      //   const querySnapshot = await getDocs(collectionRef);
      //   querySnapshot.forEach((doc) => {
      //     this.documentIds.push(doc.id);
      //   });
      // } catch (error) {
      //   console.error("Errore durante il recupero degli ID:", error);
      // }
      fetch('/api/read/patients')
          .then(async (response) => {
            if (!response.ok) {
              throw new Error('Errore nella richiesta');
            }
            const data = await response.json();
            this.patientsIDs = data.patients;
          }).catch((e) => {
              console.error(e);
      })
      this.loading = false;
    },
  },
};
</script>

<style>
.fancy-list {
  list-style: none;
  padding: 0;
}

.fancy-list li {
  padding: 10px;
  border-bottom: 3px solid gray;
  display: flex;
  align-items: center;
}

.item-icon {
  margin-right: 10px;
  font-size: 1.2em;
}

#loading {
  display: flex;
  flex-direction: column; /* Align items vertically */
  justify-content: center; /* Center vertically */
  align-items: center; /* Center horizontally */
  height: 100vh; /* Take full viewport height */
}

#loading-text {
  font-size: 2em; /* Make the text larger */
  margin-bottom: 1rem; /* Add some space between text and spinner */
}
</style>